export const EDITION_AWARENESS = 'EditionAwareness';
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarEditionAwareness';

export const NO_USERS_LEFT_COUNT = 10;
export const LIMITED_USERS_LEFT_COUNT = 7;
